
export class Config {

    public apiEndPoint(): string {
        if (window.location.origin.includes('localhost'))
            return 'http://localhost:3006/v1/';
        else if (window.location.origin.includes('adminapi'))
            return 'http://62.138.2.23:3006/admin/v1/';
        else
            return 'http://62.138.2.23:3006/admin/v1/';
    }
}



// WEBPACK FOOTER //
// ./src/app/config/config.ts